import { Link } from 'react-router-dom';
import { articles } from '@/mocks/article';

export default function ArticlePreview() {
  const displayArticles = articles.slice(0, 9);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Przewodniki i poradniki Kakobuy
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            Poznaj nasze szczegółowe artykuły, które pomogą Ci w pełni wykorzystać Kakobuy Spreadsheet. Od podstaw po zaawansowane strategie zakupowe.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {displayArticles.map((article, i) => (
            <Link
              key={article.slug}
              to={`/artykul/${article.slug}`}
              className="group bg-white rounded-xl border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-300 hover:shadow-lg animate-[fadeInUp_0.5s_ease-out]"
              style={{ animationDelay: `${i * 0.06}s` }}
            >
              <div className="aspect-[16/10] w-full overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-2.5 py-1 rounded-full">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {article.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}